/* eslint-disable no-param-reassign */
import axios from 'axios';
import {axiosMaker, errorMessage} from '../utils/utils';
import * as provinceActions from './types/provinces';
import store from '../store';


export const filterProvinces = (page, rowsPerPage, order, orderBy, searchText) => async (dispatch) => {
  if (searchText !== '' && store.getState().provinces.searchText !== searchText) {
    page = 0;
  }
  if (order !== store.getState().provinces.order || orderBy !== store.getState().provinces.orderBy) {
    page = 0;
  }
  if (searchText === null) {
    searchText = '';
  }
  dispatch({
    type: provinceActions.FILTER_PROVINCES_SENDING,
    payload: {
      provinces: [],
      dataLength: 0,
      page,
      rowsPerPage,
      order,
      orderBy,
      searchText
    }
  });
  try {
    let filter = {};
    if (page !== null && rowsPerPage !== null && order !== null && orderBy !== null && searchText !== null) {
      filter = {
        filters: {
          name: searchText
        },
        operator: 'or',
        page,
        limit: rowsPerPage,
        sort: {
          [orderBy]: order
        }
      };
    }
    const response = await axios(axiosMaker('POST', 'provinces/filter', filter, true));
    return dispatch({
      type: provinceActions.FILTER_PROVINCES_SUCCESS,
      payload: {
        provinces: response.data.results,
        dataLength: response.data.total
      }
    });
  } catch (e) {
    const error = e.response;

    return dispatch({
      type: provinceActions.FILTER_PROVINCES_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};

export const getProvinces = () => async (dispatch) => {
  dispatch({
    type: provinceActions.GET_PROVINCES_SENDING,
    payload: {
      provinces: [],
      dataLength: 0
    }
  });
  try {
    const data = {
      sort: {
        name: 'asc'
      },
      filters: {}
    };
    const response = await axios(axiosMaker('POST', 'provinces/filter', data, true));
    return dispatch({
      type: provinceActions.GET_PROVINCES_SUCCESS,
      payload: {
        provinces: response.data.results,
        dataLength: response.data.results.length
      }
    });
  } catch (e) {
    const error = e.response;

    return dispatch({
      type: provinceActions.GET_PROVINCES_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};

export const createProvince = data => async (dispatch) => {
  dispatch({
    type: provinceActions.CREATE_PROVINCE_SENDING,
    payload: {}
  });
  try {
    await axios(axiosMaker('POST', 'provinces', data, true));
    return dispatch({
      type: provinceActions.CREATE_PROVINCE_SUCCESS,
      payload: {}
    });
  } catch (e) {
    const error = e.response;
    return dispatch({
      type: provinceActions.CREATE_PROVINCE_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};

export const updateProvince = (id, province) => async (dispatch) => {
  dispatch({
    type: provinceActions.UPDATE_PROVINCE_SENDING,
    payload: {}
  });
  try {
    await axios(axiosMaker('PATCH', `provinces/${id}`, province, true));
    return dispatch({
      type: provinceActions.UPDATE_PROVINCE_SUCCESS,
      payload: {}
    });
  } catch (e) {
    const error = e.response;

    return dispatch({
      type: provinceActions.UPDATE_PROVINCE_FAILED,
      payload: {
        error,
        message: errorMessage(error)
      }
    });
  }
};
